import { g as i } from "./themes-5f0b3c3d.mjs";
const t = {
  body: {
    regular: i.primitive.fontWeights.inter.regular,
    // 400
    medium: i.primitive.fontWeights.inter.medium,
    // 500
    semibold: i.primitive.fontWeights.inter.semiBold
    // 600
  },
  headline: i.primitive.fontWeights.fordF1.semiBold,
  // 500
  eyebrow: i.primitive.fontWeights.fordF1.semiBold
  // 500
};
export {
  t as f
};
